import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c54e5516"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Настройки")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Направление", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Количество слов", -1))
const _hoisted_4 = { style: {"margin":"0 auto"} }
const _hoisted_5 = { style: {"vertical-align":"middle","padding-top":"8px","padding-right":"35px"} }
const _hoisted_6 = {
  colspan: "2",
  style: {"padding":"15px 0"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Звук", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Примеры", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "wrapper",
  style: {"text-align":"center"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"9pt"} }, " Слова также можно выбирать клавишами 1-9, Enter – продолжить "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://t.me/magic_jack",
    target: "_blank",
    class: "found-a-mistake"
  }, "Нашли ошибку?")
], -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("ОК")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_select = _resolveComponent("it-select")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_it_number_input = _resolveComponent("it-number-input")!
  const _component_it_checkbox = _resolveComponent("it-checkbox")!
  const _component_it_switch = _resolveComponent("it-switch")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_it_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal())),
      type: "primary",
      tabindex: "-1",
      ref: "settingsButton",
      style: {"width":"150px","margin":"0 auto"}
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 512),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.isModalVisible,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      "closable-mask": false,
      width: "420px"
    }, {
      body: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_it_select, {
          modelValue: _ctx.direction.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.direction.value) = $event)),
          options: _ctx.direction.options,
          style: {"width":"250px"},
          "track-by": "value"
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_component_it_divider),
        _hoisted_3,
        _createVNode(_component_it_number_input, {
          modelValue: _ctx.wordsAmount.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.wordsAmount.value) = $event)),
          stepPoints: true,
          min: _ctx.wordsAmount.min,
          max: _ctx.wordsAmount.max,
          style: {"width":"30px","text-align":"center"}
        }, null, 8, ["modelValue", "min", "max"]),
        _createVNode(_component_it_divider),
        _createElementVNode("h4", null, "Наборы слов (" + _toDisplayString(_ctx.totalWordsChosen) + " / " + _toDisplayString(_ctx.totalWords) + ")", 1),
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dictionaryCategories.raw, (category, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_5, [
                  _createVNode(_component_it_checkbox, {
                    label: _ctx.getCategoryLabel(category),
                    key: index,
                    modelValue: _ctx.dictionaryCategories.chosen[category.id],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dictionaryCategories.chosen[category.id]) = $event),
                    disabled: _ctx.dictionaryCategories.chosen[category.id]
                && _ctx.chosenCategoriesId.length === 1
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "disabled"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_it_number_input, {
                    min: _ctx.dictionaryCategories.settings.minWordsAmount,
                    max: category.quantity,
                    step: _ctx.dictionaryCategories.settings.editingStep,
                    "resize-on-write": true,
                    modelValue: _ctx.dictionaryCategories.amounts[category.id],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.dictionaryCategories.amounts[category.id]) = $event),
                    style: {"width":"50px","text-align":"center"}
                  }, null, 8, ["min", "max", "step", "modelValue", "onUpdate:modelValue"])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("tfoot", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_it_button, {
                  type: "primary",
                  style: {"margin":"0 auto 0 auto"},
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeWordAmountsLimits()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isMaximumWordAmountsInstalled ? 'Максимум' : 'Минимум'), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createVNode(_component_it_divider),
        _hoisted_7,
        _createVNode(_component_it_switch, {
          modelValue: _ctx.sound.onSucceedAttempt,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sound.onSucceedAttempt) = $event)),
          type: "success",
          label: "При правильном ответе"
        }, null, 8, ["modelValue"]),
        _hoisted_8,
        _createVNode(_component_it_switch, {
          modelValue: _ctx.sound.onFailedAttempt,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sound.onFailedAttempt) = $event)),
          type: "danger",
          label: "При неправильном ответе"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_it_divider),
        _hoisted_9,
        _createVNode(_component_it_switch, {
          modelValue: _ctx.examples.displayOnQuestFinish,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.examples.displayOnQuestFinish) = $event)),
          type: "success",
          label: "Отображать примеры после окончания"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_it_divider),
        _hoisted_10
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_it_button, {
          type: "primary",
          onClick: _ctx.hideModal,
          style: {"margin":"0 auto"}
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}